import React from 'react';
import styles from './index.module.scss';

const NotAllowed = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>Даний контент<br />призначений лише для<br />повнолітніх осіб</p>
      </div>
    </div>
  );
}

export default NotAllowed;
